Ext.define('SA.BusinessesLimitCheck', {
    constructor(value) {
        this.check = new SA.PointsDatasetLimit(value);
    },

    canExport() {
        return !this.isBeyondLimit();
    },

    canHideWindow() {
        return true;
    },

    isBeyondLimit() {
        return this.check.isBeyondLimit();
    },

    maybeGetMessage() {
        if (this.isBeyondLimit()) {
            return {xtype: 'beyond-limit-businesses-message', data: this.check.serialize()};
        }

        return null;
    }
});